import { Recipe } from 'common/hooks/useProducer';
import exhaustivnessCheck from 'common/utils/exhaustivnessCheck';
import {
  UserAccountBalancesState,
  UserAccountsState,
  UserAccountsWithBalanceState,
  AccountOperatingsState,
  AccountOwedsState,
  AccountsState,
  XratesState,
  AccountCustomersState,
  AccountMovementsState,
} from './states';
import {
  UserAccountsActions,
  UserAccountBalancesActions,
  UserAccountsWithBalanceActions,
  AccountOperatingsActions,
  AccountOwedsActions,
  AccountsActions,
  XratesActions,
  AccountCustomersActions,
  AccountMovementsActions,
  AdjustAccountActions,
  TransferAdjustAccountActions,
} from './actions';
import { APIRequestState } from 'api';

// #region Account
export const userAccountsRecipe: Recipe<
  UserAccountsState,
  UserAccountsActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts/user/started':
      draft.pending = true;
      return;

    case 'accounts/user/finished':
      draft.pending = false;
      draft.accounts = action.accounts;
      draft.count = action.count || 0;
      draft.next = action.next;
      draft.previous = action.previous;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
export const accountsRecipe: Recipe<AccountsState, AccountsActions> = (
  draft,
  action
) => {
  switch (action.type) {
    case 'accounts/started':
      draft.pending = true;
      return;

    case 'accounts/finished':
      draft.pending = false;
      draft.accounts = action.accounts;
      draft.count = action.count || 0;
      draft.next = action.next;
      draft.previous = action.previous;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region AccountBalance
export const userAccountsBalanceRecipe: Recipe<
  UserAccountBalancesState,
  UserAccountBalancesActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts/user/balances/started':
      draft.pending = true;
      return;

    case 'accounts/user/balances/finished':
      draft.pending = false;
      draft.balances = action.balances;
      draft.count = action.count || 0;
      draft.next = action.next;
      draft.previous = action.previous;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region AccountWithBalance
export const userAccountsWithBalanceRecipe: Recipe<
  UserAccountsWithBalanceState,
  UserAccountsWithBalanceActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts_with_balance/user/started':
      draft.pending = true;
      return;

    case 'accounts_with_balance/user/finished':
      draft.pending = false;
      draft.accounts = action.accounts;
      draft.count = action.count || 0;
      draft.next = action.next;
      draft.previous = action.previous;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region AccountOperating
export const accountOperatingsRecipe: Recipe<
  AccountOperatingsState,
  AccountOperatingsActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts/operating/started':
      draft.pending = true;
      return;

    case 'accounts/operating/finished':
      draft.pending = false;
      draft.operatings = action.operatings;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region AccountOwed
export const accountOwedsRecipe: Recipe<
  AccountOwedsState,
  AccountOwedsActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts/owed/started':
      draft.pending = true;
      return;

    case 'accounts/owed/finished':
      draft.pending = false;
      draft.oweds = action.oweds;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region Xrates
export const xratesRecipe: Recipe<XratesState, XratesActions> = (
  draft,
  action
) => {
  switch (action.type) {
    case 'xrates/started':
      draft.pending = true;
      return;

    case 'xrates/finished':
      draft.pending = false;
      draft.xrates = action.xrates;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region AccountOwed
export const accountCustomersRecipe: Recipe<
  AccountCustomersState,
  AccountCustomersActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts/customers/started':
      draft.pending = true;
      return;

    case 'accounts/customers/finished':
      draft.pending = false;
      draft.customers = action.customers;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region AccountMovements
export const accountMovementsRecipe: Recipe<
  AccountMovementsState,
  AccountMovementsActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts/movements/started':
      draft.pending = true;
      return;

    case 'accounts/movements/finished':
      draft.pending = false;
      draft.movements = action.movements;
      draft.count = action.count || 0;
      draft.next = action.next;
      draft.previous = action.previous;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region AdjustAccount
export const adjustAccountRecipe: Recipe<
  APIRequestState,
  AdjustAccountActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts/adjust/started':
      draft.pending = true;
      return;

    case 'accounts/adjust/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const transferAdjustAccountRecipe: Recipe<
  APIRequestState,
  TransferAdjustAccountActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts/transfer-adjust/started':
      draft.pending = true;
      return;

    case 'accounts/transfer-adjust/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion
